import React from 'react'
import coinIcon from "../assets/he 8.png";

const CoinOptionPS = ({ option, selectedOption, handleQuantityChange }) => {
  return (
    <div
      className="relative cursor-pointer"
      onClick={() => handleQuantityChange(option.value)}
    >
      <div className={`border rounded-xl py-3 px-3 flex items-center justify-center ${selectedOption === option.value
        ? 'bg-[#02BBFF] border-[#02BBFF] text-black'
        : 'bg-[#191919] border-[#02BBFF] text-[#02BBFF]'
        }`}>
        <img src={coinIcon} alt="Coin" className="w-5 h-5 mr-2" />
        <span className="font-bold text-[12px] leading-none tracking-tight">
          {option.value}K
        </span>
      </div>
      {option.bonus > 0 && (
        <div className="absolute -top-3 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[7px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
          +{option.bonus}K <span className="italic">Coins</span>
        </div>
      )}
    </div>
  )
}

export default CoinOptionPS